import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import channelsReducer from './channels/slice';
import collectionReducer from './collection/slice';
import globalVarsReducer from './globalVars/slice';
import menuReducer from './menu/slice';
import pageReducer from './page/slice';
import titlesReducer from './titles/slice';

export const store = configureStore({
  reducer: {
    channels: channelsReducer,
    collection: collectionReducer,
    globalVars: globalVarsReducer,
    menu: menuReducer,
    pageDraftables: pageReducer,
    titles: titlesReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>;
